import { format } from "numerable";
import numbro from "numbro";
import Format = numbro.Format;

export const numerable = (pattern: string, options?: Object) => (n: number) =>
  format(n, pattern, options);

export const numbroFormat = (pattern: Format) => (n: number) =>
  numbro(n).format(pattern);
